






import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Stepper extends Vue {
    @Prop({ default: 0 })
    public step!: number;

    @Prop({ default: 1 })
    public amount!: number;

    get width() {
        return `${100 / this.amount * this.step}%`;
    }

}
